import { useState } from 'react';
import { BordBadge } from 'bord-design-system';
import QuoteStatusSelector from 'views/Quote/QuoteDetails/components/QuoteStatusSelector/QuoteStatusSelector';
import QuoteCancelModal from 'views/Quote/components/QuoteCancelModal/QuoteCancelModal';
import { IQuoteStatus } from 'types/quoteDetails.types';
import './QuoteStatusRow.scss';

interface IQuoteStatusRow {
  quoteId?: number;
  quoteStatus?: IQuoteStatus;
  parentQuoteId?: number;
  onCancelSuccess?: () => Promise<void>;
}

/**
 * Fila de estado de cotización: selector de estado, modal de cancelación y badge de recotización opcional.
 * Compartido entre QuoteDetailHeader y QuoteEditorHeader.
 */
const QuoteStatusRow = ({ quoteId, quoteStatus, parentQuoteId, onCancelSuccess }: IQuoteStatusRow) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  return (
    <div className="quoteStatusRow">
      {quoteStatus && (
        <QuoteStatusSelector quoteStatus={quoteStatus} onCancelSelect={() => setIsCancelModalOpen(true)} />
      )}
      {parentQuoteId && (
        <span className="requoteBadge">
          <BordBadge label={`Recotizada | N°${parentQuoteId}`} variant="gradient" size="small" />
        </span>
      )}
      {quoteId && (
        <QuoteCancelModal
          quoteId={quoteId}
          open={isCancelModalOpen}
          onClose={() => setIsCancelModalOpen(false)}
          onSuccess={onCancelSuccess}
        />
      )}
    </div>
  );
};

export default QuoteStatusRow;
